var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 75,
    viewBox: "0 0 60 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2812 12.4654C46.1187 12.4654 43.8625 13.8435 41.7812 16.8372L35.7812 25.4529V0.859131H21.4688V25.4529L15.4688 16.8372C13.3907 13.8435 11.1344 12.4654 7.96881 12.4654C3.19381 12.4654 0.0156914 15.9904 6.63637e-05 20.3341C-0.0124336 24.0529 1.74069 26.4779 5.43756 28.8591L28.6251 43.7966L51.8125 28.8591C55.5094 26.4779 57.2625 24.0529 57.25 20.3341C57.2375 15.9904 54.0562 12.4654 49.2812 12.4654Z",
    fill: "#0AAD0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6249 47.3757C42.4062 47.3757 53.7031 57.6632 53.6719 72.4257H3.57806C3.54993 57.6695 14.8437 47.3757 28.6249 47.3757Z",
    fill: "#FF7009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider4);
export default __webpack_public_path__ + "static/media/slider-4.1805adaf42fffcadc2f26fe43ee7cfb0.svg";
export { ForwardRef as ReactComponent };